import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";

export const fetchSubCategorys = createAsyncThunk(
  "subcategory/fetchSubCategorys",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search.trim());
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    const filterPayload = FilterBuilder(filters ?? []);

    const body = {
      filters: filterPayload,
    };
    const response: any = await Axios.post(
      `${API_ENDPOINT?.MASTERS?.SUB_CATEGORY?.LIST}?${params.toString()}`,
      body,
    );
    return {
      data: response.data.data || [],
      rowCount: response.data.count || 0,
    };
  },
);

export const fetchSubCategoryById = createAsyncThunk(
  "subcategory/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(
        `${API_ENDPOINT.MASTERS.SUB_CATEGORY.DETAIL(id)}`,
      );

      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch SubCategory by ID",
      );
    }
  },
);

export const fetchSubCategoryByDropDown = createAsyncThunk(
  "SubCategory/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_ENDPOINT.MASTERS.SUB_CATEGORY.DROPDOWN}`,
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch SubCategory list",
      );
    }
  },
);

export const fetchSuCategoryBasedOnSelectedCategory = createAsyncThunk(
  "district/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_ENDPOINT.MASTERS.SUB_CATEGORY.DROPDOWN_BY_CATEGORY(id)}`,
      );

      return response?.data?.data || [];
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch SubCategory by ID",
      );
    }
  },
);

export const updateSubCategory = createAsyncThunk(
  "subcategory/updateSubCategory",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `${API_ENDPOINT.MASTERS.SUB_CATEGORY.UPDATE(data.id)}`,
        data,
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update SubCategory",
      );
    }
  },
);

export const updateStatusInSubCategory = createAsyncThunk(
  "category/updateStatusInSubCategory",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.patch(
        `${API_ENDPOINT.MASTERS?.SUB_CATEGORY.STATUS_UPDATE(id)}`,
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update status in sub category",
      );
    }
  },
);

export const addSubCategory = createAsyncThunk(
  "subcategory/addSubCategory",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(
        `${API_ENDPOINT.MASTERS.SUB_CATEGORY.CREATE}`,
        data,
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add SubCategory");
    }
  },
);

export const deleteSubCategory = createAsyncThunk(
  "subcategory/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      await Axios.delete(`${API_ENDPOINT.MASTERS.SUB_CATEGORY.DELETE(id)}`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  },
);

export const exportSubCategoryCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();
  if (search) params.append("search", search);

  const filterPayload = FilterBuilder(filters ?? []);

  const body = {
    filters: filterPayload,
  };

  const response = await Axios.post(
    `${API_ENDPOINT.MASTERS.SUB_CATEGORY.EXPORT}?${params.toString()}`,
    body,
    { responseType: "blob" },
  );

  return {
    blob: response.data,
    filename: `${
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "subcategory"
    }_${new Date().toISOString().split("T")[0]}.csv`,
  };
};
